import type { InjectionKey } from 'vue'
import type { IDescriptionsInject } from './descriptions.type'

export const TwDescriptionsKey =
  'TwDescriptions' as any as InjectionKey<IDescriptionsInject>
